<template>
  <div>
    <Top />
    <div class="maindiv yindex-wrap">
      <Banner />
      <div class="sys htmldiv tright twhite ofhidden">
        <a href="/lms/web" class="zbtn zbtn-gcoffee fr">
          <div class="fs24">我要报名</div>
          <div class="fmt tupper">Sign Up</div>
        </a>
      </div>
      <div class="cndiv htmldiv fs0">
        <div class="cdiv wd654 ht450 dinline-block prelative vtop" v-if="schools[0]">
          <img :src="schools[0]['image']" width="654" height="436" />
          <div class="bm pabsolute twhite pl20 pr20 fs14">
            <div class="fs26 tcenter pt35 pb30">{{schools[0]['name']}}</div>
            <div class="lh20 int ofhidden mb10">{{schools[0]['description']}}</div>
            <div class="tc-coffee mb15">网址： {{schools[0]['url']}}</div>
            <div class="tc-coffee">地址：{{schools[0]['address']}}</div>
            <div class="tcenter" style="margin-top: 10px;">
              <a href="https://www.5any.com/PortalSite/index.htm" target="_blank" >
                <img src="../../../assets/images/cq.png" />
              </a>
            </div>
          </div>
        </div>
        <div class="cdiv wd654 ht450 dinline-block prelative vtop" v-else>

          <img src="../../../assets/images/ot_01.jpg" width="654" height="436" />
          <div class="bm pabsolute twhite pl20 pr20 fs14">
            <div class="fs26 tcenter pt35 pb30">重庆大学</div>
            <div class="lh20 int ofhidden mb10">　　重庆大学是教育部直属的全国重点大学，是国家“211工程”和“985工程”重点建设的高水平研究型综合性大学，是国家“世界一流大学建设高校（A类）”。学校地处国家西南工商业重镇、长江上游经济中心—重庆市，坐落在人文荟萃的文化名区—沙坪坝区。</div>
            <div class="tc-coffee mb15">网址： www.cqu.edu.cn</div>
            <div class="tc-coffee">地址：重庆市沙坪坝区沙正街174号</div>
            <div class="tcenter" style="margin-top: 25px;">
              <a href="https://tms.5any.com/Enroll/Student/" target="_blank" class="zbtn zbtn-gcoffee fs16 br5 mat hbig">我要报名</a>
            </div>
          </div>
        </div>
        <div class="ndiv wd590 ht450 ml35 dinline-block vtop">
          <div class="ml15 pb10 mb20 pl5 yst">
            <router-link :to="isNotice==true?'/dedu/notice/index':'/dedu/enrollment/index'" class="fr tc9 fs16 mr10 mt10 hc-coffee">
              更多&gt;&gt;
            </router-link>
            <span class="fs26 tcenter cpointer" :class="{fbold: isNotice}" @mouseover="isNotice=true">公告信息</span>
            <span class="fs24 tcenter ml15 mr15">|</span>
            <span class="fs26 tcenter cpointer" :class="{fbold: !isNotice}" @mouseover="isNotice=false">招生资讯</span>
          </div>
          <div class="cont pt5">
            <div v-show="isNotice" class="pl5 pr5 trans3">
               <router-link v-for="(item,index) in notice" :key="item.id" :to="`/dedu/notice/detail?id=${item.id}`" tag="div" class="mb10 fs16 snt snt-coffee cpointer ofhidden prelative">
                 <span class="fs tc9 fr pabsolute mr15">{{item.release_time}}</span>
                 {{item.title}}
               </router-link>
            </div>
            <div v-show="!isNotice" class="pl5 pr5 trans3">
               <router-link v-for="(item,index) in enrollmentInfo" :key="item.id" :to="`/dedu/enrollment/detail?id=${item.id}`" tag="div" class="mb10 fs16 snt snt-coffee cpointer ofhidden prelative">
                 <span class="fs tc9 fr pabsolute mr15">{{item.release_time}}</span>
                 {{item.title}}
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="sddiv fs0 htmldiv mt15">
        <div class="dsdiv wd654 ht420 dinline-block prelative vtop fs14">
          <div class="pb10 mb25 pl5 yst">
            <router-link to="/dedu/professional/index" class="fr tc9 fs16 mr10 mt10 hc-coffee">
              更多&gt;&gt;
            </router-link>
            <span class="fs26 fbold tcenter cpointer">报读专业</span>
          </div>
          <div class="cont pl5">
            <router-link :to="`/dedu/professional/detail?id=${item.id}`" tag="div" class="sdiv dinline-block br5 pl25 pr25 pt25 pb20 cpointer trans3 vtop" v-for="(item,index) in proIntroduction" :key="item.id" v-if="index<2">
              <div class="fs20 fbold mb20">{{item.name}}</div>
              <div class="tc-coffee mb5">学　　制：{{item.years}}年</div>
              <div class="tc-coffee mb15">修业年限：	{{item.study_year}} 年</div>
              <div class="tc9 mb5">主要课程：	</div>
              <div class="tc9 lh18 sps ofhidden">
                {{item.course}}
              </div>
            </router-link>
          </div>
        </div>
        <div class="ndiv wd590 ht420 ml35 dinline-block vtop">
          <div class="ml15 pb10 mb20 pl5 yst">
            <router-link to="/dedu/student/index" class="fr tc9 fs16 mr10 mt10 hc-coffee">
              更多&gt;&gt;
            </router-link>
            <span class="fs26 tcenter fbold">招生简章</span>
          </div>
          <div class="cont pt5">
            <div class="pl5 pr5 trans3">
               <router-link v-for="(item,index) in students" :key="item.id" :to="`/dedu/student/detail?id=${item.id}`" tag="div" class="mb10 fs16 snt snt-coffee cpointer ofhidden prelative">
                 <span class="fs tc9 fr pabsolute mr15">{{item.release_time}}</span>
                 {{item.title}}
              </router-link>
            </div>
          </div>
        </div>
      </div>

     <!-- <div class="dsdiv mt35">
        <div class="htmldiv">
          <div class="yst prelative pl30">
            <router-link to="/dedu/professional/index" class="more fr tc9 mr5 br2 mt15">更多+</router-link>
            <div class="bcur pabsolute br50 bgw tcenter trans3"></div>
            <div class="tt prelative dinline-block prelative pb10 fs24">
              <span class="tc-coffee">专业</span>介绍
            </div>
          </div>
          <div class="cont fs0 tcenter pt25">
            <EduImgItem :controller="'dedu'" v-for="(item,index) in proIntroduction" v-if="index<4" :key="index" :index="index" :item="item" />
          </div>
        </div>
      </div> -->

     <!-- <div class="cediv mt35">
        <div class="htmldiv">
          <div class="yst prelative pl30">
            <router-link to="/dedu/school/index" class="more fr tc9 mr5 br2 mt15">更多+</router-link>
            <div class="bcur pabsolute br50 bgw tcenter trans3"></div>
            <div class="tt prelative dinline-block prelative pb10 fs24">
              <span class="tc-coffee">走进</span>网院
            </div>
          </div>
          <div class="cont pl10 pt25 pb20">
            <WSchoolItem v-for="(item,index) in schools" v-if="index<6" :key="index" :index="index" :item="item"/>
          </div>
        </div>
      </div> -->

      <!-- <div class="newsdiv htmldiv pb30">
        <div class="notice sdiv dinline-block vtop">
          <div class="yst prelative pl30">
            <router-link to="/dedu/notice/index" class="more fr tc9 mr5 br2 mt15">更多+</router-link>
            <div class="bcur pabsolute br50 bgw tcenter trans3"></div>
            <div class="tt prelative dinline-block prelative pb10 fs24">
              <span class="tc-coffee">通知</span>公告
              <span class="farial fs16 tc9 tupper">Notice</span>
            </div>
          </div>
          <div class="cont pt20">
            <NoticeItem v-for="(item,index) in notice" v-if="index<4" :key="index" :index="index" :item="item"/>
          </div>
        </div>
        <div class="sdiv dinline-block vtop">
          <div class="yst prelative pl30">
            <router-link to="/dedu/student/index" class="more fr tc9 mr5 br2 mt15">更多+</router-link>
            <div class="bcur pabsolute br50 bgw tcenter trans3"></div>
            <div class="tt prelative dinline-block prelative pb10 fs24">
              <span class="tc-coffee">招生</span>简章
              <span class="farial fs16 tc9 tupper">Admissions</span>
            </div>
          </div>
          <div class="cont pt30">
            <Articlee :action="'student'" v-for="(item,index) in students" v-if="index<9" :key="index" :index="index" :item="item"/>
          </div>
        </div>
        <div class="sdiv dinline-block vtop">
          <div class="yst prelative pl30">
            <router-link to="/dedu/policy/index" class="more fr tc9 mr5 br2 mt15">更多+</router-link>
            <div class="bcur pabsolute br50 bgw tcenter trans3"></div>
            <div class="tt prelative dinline-block prelative pb10 fs24">
              <span class="tc-coffee">政策</span>文件
              <span class="farial fs16 tc9 tupper">policy</span>
            </div>
          </div>
          <div class="cont pt30">
            <Articlee :action="'policy'" v-for="(item,index) in policy" v-if="index<9" :key="index" :index="index" :item="item"/>
          </div>
        </div>
      </div> -->
    </div>
    <Bottom />
  </div>
</template>

<script>
  import Top from '../top'
  import Banner from '../banner'
  import EduImgItem from "../../index/edu-img-item"
  import WSchoolItem from '../w-school-item'
  import NoticeItem from '../notice-item'
  import Articlee from '../articlee'
  import Bottom from "../bottom";
  export default {
    name: "index",
    data () {
      return {
        'proIntroduction': [],
        'schools': [],
        'notice': [],
        'students': [],
        'policy': [],
        'isNotice': true,
        'enrollmentInfo':[],
      }
    },
    components:{
      Bottom,
      Top,
      Banner,
      EduImgItem,
      WSchoolItem,
      NoticeItem,
      Articlee,
    },
    created() {
      this.$request.get('distance-learning/index', {},response => {
        console.log(response);
        if(response.status == 200){
          this.proIntroduction = response.data.data.distanceLearningMajorList;
          this.schools = response.data.data.schoolList;
          this.notice = response.data.data.noticeList;
          this.students = response.data.data.enrollmentList;
          this.policy = response.data.data.policyDocumentList;
          this.enrollmentInfo = response.data.data.enrollmentInfo;
        }
      },error => {
        console.log(error);
      })
    },
  }
</script>

<style scoped>
  .yst{border-bottom: 1px solid #b2792a;}

  .sys{margin-top: -45px;}

  .sys .zbtn{padding: 10px 45px 0 85px;height: 72px;background: #b2792a url(../../../assets/images/cn1.png) 10px -423px;text-align: left;}
  .sys .zbtn:hover{background-color: #f1a843;}

  .cndiv{margin-top: 50px;}
  .cndiv .cdiv{height: 436px;}
  .cndiv .int{height: 180px;}
  .cndiv .bm{top: 0;bottom: 0;left: 315px;right: 0;background: rgba(0, 0, 0, .6);}
  .cndiv .zbtn{padding: 7px 25px;}
  .cndiv .snt{margin-bottom: 5px;}

  .dsdiv .sdiv{width: 305px;height: 305px;background: #f7f7f7 url(../../../assets/images/cn2.png) 255px -265px no-repeat;}
  .dsdiv .sdiv:nth-child(2n + 1){margin-right: 25px;}
  .dsdiv .sdiv:hover{box-shadow: 0 0 15px #666;;background-position: 260px -265px;color: #b2792a;}
  .dsdiv .sps{height: 120px;}
  .sddiv .snt{margin-bottom: 5px;}
</style>



// WEBPACK FOOTER //
// src/components/dedu/index/index.vue